class MParticle {
  // Static cookie name for mParticle device id
  private static mParticleCookieName = 'gfmUserId'

  public static getDeviceId = () => {
    // Check if we have a custom mParticle cookie with a device id
    const mParticleCookie = document.cookie
      .split('; ')
      .find((cookie) => cookie.startsWith(`${this.mParticleCookieName}=`))

    if (mParticleCookie) {
      const deviceId = mParticleCookie.split('=')[1]

      return deviceId
    }

    // Otherwise, create the cookie with a random UUIDv2 format and return it
    const deviceId = this.generateUUIDv2()

    document.cookie = `${this.mParticleCookieName}=${deviceId}; Path=/; SameSite=Lax;${
      process.env.NODE_ENV === 'production' ? ' Secure;' : ''
    }`

    return deviceId
  }

  private static generateUUIDv2(uid?: number, domain?: number): string {
    uid = uid || 1000 // Default UID
    domain = domain || 0 // Domain (0 = person, 1 = group, etc.)

    // Offset from Unix epoch (1970) to Gregorian epoch (1582)
    const gregorianOffset = 12219292800000

    // Time since Gregorian epoch in 100ns intervals
    const timeNow = Date.now() + gregorianOffset
    const timestamp100ns = timeNow * 10000

    // Break timestamp into parts (simulate 60-bit timestamp)
    const timeLow = uid & 0xffffffff // Replaced with UID
    const timeMid = (timestamp100ns / Math.pow(2, 32)) & 0xffff
    let timeHi = (timestamp100ns / Math.pow(2, 48)) & 0x0fff
    timeHi |= 2 << 12 // Set version to 2

    // Generate 14-bit clock sequence with variant bits
    const clockSeqHi = Math.floor(Math.random() * 0x40) | 0x80 // variant 10xx xxxx
    const clockSeqLow = Math.floor(Math.random() * 0x100)

    // Node (MAC or random 6 bytes)
    const node = []

    for (let i = 0; i < 6; i++) {
      node.push(Math.floor(Math.random() * 256))
    }

    function hex(n: number, width: number) {
      let s = n.toString(16)

      while (s.length < width) {
        s = '0' + s
      }

      return s
    }

    return [
      hex(timeLow, 8),
      hex(timeMid, 4),
      hex(timeHi, 4),
      hex(clockSeqHi, 2) + hex(clockSeqLow, 2),
      node
        .map(function (b) {
          return hex(b, 2)
        })
        .join(''),
    ].join('-')
  }
}

export default MParticle
